import React from 'react';
import {
  Flex,
  Button,
  Box,
  Stack,
  Spinner,
  AbsoluteCenter,
} from '@chakra-ui/react';
import Card from 'components/card/Card';

const TableWrapper = ({
  children,
  list,
  loading,
  currentPage,
  setCurrentPage,
  listTotal,
  itemsPerPage,
  isError,
}) => {
  const totalPages = Math.ceil(listTotal / itemsPerPage);
  const pageItems = [];

  for (let i = 1; i <= totalPages; i++) {
    pageItems.push(
      <Button
        key={i}
        size='sm'
        variant='ghost'
        colorScheme={i === currentPage ? 'blue' : undefined}
        onClick={() => setCurrentPage(i)}>
        {i}
      </Button>
    );
  }

  return (
    <Card
      direction='column'
      w='100%'
      px='0px'
      overflowX='hidden'>
      <Flex
        minHeight='180px'
        overflowX='auto'
        sx={{
          '::-webkit-scrollbar': {
            display: 'block', // Ensures the scrollbar is always visible in Webkit browsers
            height: '6px',
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: '#888', // Customize scrollbar thumb color
            borderRadius: '3px',
          },
          '::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1', // Customize scrollbar track color
            borderRadius: '3px',
            mx: 2,
          },
        }}>
        {loading && (
          <Box height='300px'>
            <AbsoluteCenter>
              <Spinner size='xl' />
            </AbsoluteCenter>
          </Box>
        )}
        {children}
      </Flex>

      {isError !== '' && <h2>{isError}</h2>}

      {/* Display the pagination */}
      <Stack
        direction='row'
        spacing={2}
        mt={4}
        justifyContent='center'>
        <Box>
          <Button
            size='sm'
            isDisabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}>
            Previous
          </Button>
        </Box>

        <Flex
          height={10}
          maxWidth='58%'
          overflowX='auto'
          sx={{
            '::-webkit-scrollbar': {
              display: 'block', // Ensures the scrollbar is always visible in Webkit browsers
              height: '6px',
            },
            '::-webkit-scrollbar-thumb': {
              backgroundColor: '#888', // Customize scrollbar thumb color
              borderRadius: '3px',
            },
            '::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1', // Customize scrollbar track color
              borderRadius: '3px',
              mx: 2,
            },
          }}>
          {pageItems}
        </Flex>

        <Box>
          <Button
            size='sm'
            isDisabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}>
            Next
          </Button>
        </Box>
      </Stack>
    </Card>
  );
};

export default TableWrapper;
